/**
 * Shared formatting utilities
 */

// Palette de couleurs style Mario/Zelda
const AVATAR_COLORS = [
  '#E52521', // Rouge Mario
  '#049CD8', // Bleu
  '#43B047', // Vert Luigi
  '#FBD000', // Jaune
  '#9B59B6', // Violet
  '#F39C12', // Orange
];

/**
 * Génère une couleur cohérente à partir d'un nom
 * La même personne aura toujours la même couleur
 */
export function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

/**
 * Extrait les initiales d'un nom (max 2 caractères)
 * "Jean Dupont" → "JD"
 * "Alice" → "AL"
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();
}

/**
 * Formate des secondes en MM:SS
 * 125 → "2:05"
 */
export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
